module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "edit-category-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "400px"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.loading) ? _c('vue-spinner') : _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('edit-category.title')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Title",
      "name": "title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('edit-category.title')),
      expression: "errors.has('edit-category.title')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('edit-category.title')))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editCategory.apply(null, arguments)
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeCategory.apply(null, arguments)
      }
    }
  }, [_vm._v("Remove category")]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("EDIT CATEGORY")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53953035","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HelpTutorials/EditCategoryModal.vue
// module id = 1642
// module chunks = 1